import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["tooltipTitle", "icon", "customIcon", "separatorTop", "disabled", "loading"];
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ContextMenuItem/ContextMenuItem.tsx";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Edit, CreateNewFolder, Search, DeleteSweep } from '@mui/icons-material';
import { Typography } from '@gmini/ui-kit/lib/Typography';
import { CircularProgress } from '@gmini/ui-kit/lib/CircularProgress';
import { ContentPaste, Tooltip, RoundMultiplyStop, WarningOutlined, Chain, Copy, Trash, Recovery, PlusFilter, SettingFilter, CrossOutedFilter, SuccessfulContentPaste } from '@gmini/ui-kit';
import { Archive } from '@gmini/ui-kit/lib/icons/Archive';
import { MenuItem, ListItemIcon, ExpandLess, Divider } from "./ContextMenuItem.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var Icon;

(function (Icon) {
  Icon["CREATE"] = "CREATE";
  Icon["EDIT"] = "EDIT";
  Icon["MOVE"] = "MOVE";
  Icon["PASTE"] = "PASTE";
  Icon["DELETE"] = "DELETE";
  Icon["DELETEALL"] = "DELETEALL";
  Icon["SEARCH"] = "SEARCH";
  Icon["COLLAPSE"] = "COLLAPSE";
  Icon["CREATE_ISSUE"] = "CREATE_ISSUE";
  Icon["LINK_ISSUE"] = "LINK_ISSUE";
  Icon["ARCHIVE"] = "ARCHIVE";
  Icon["COPY"] = "COPY";
  Icon["RECOVERY"] = "RECOVERY";
  Icon["CREATE_FILTER"] = "CREATE_FILTER";
  Icon["EDIT_FILTER"] = "EDIT_FILTER";
  Icon["REMOVE_FILTER"] = "REMOVE_FILTER";
  Icon["PASTE_FROM_SEARCH"] = "PASTE_FROM_SEARCH";
})(Icon || (Icon = {}));

var getIcon = function getIcon(icon) {
  switch (icon) {
    case Icon.CREATE:
      return /*#__PURE__*/_jsx(CreateNewFolder, {});

    case Icon.MOVE:
      return /*#__PURE__*/_jsx(RoundMultiplyStop, {});

    case Icon.PASTE:
      return /*#__PURE__*/_jsx(ContentPaste, {});

    case Icon.EDIT:
      return /*#__PURE__*/_jsx(Edit, {});

    case Icon.DELETE:
      return /*#__PURE__*/_jsx(Trash, {});

    case Icon.DELETEALL:
      return /*#__PURE__*/_jsx(DeleteSweep, {});

    case Icon.SEARCH:
      return /*#__PURE__*/_jsx(Search, {});

    case Icon.COLLAPSE:
      return /*#__PURE__*/_jsx(ExpandLess, {});

    case Icon.CREATE_ISSUE:
      return /*#__PURE__*/_jsx(WarningOutlined, {});

    case Icon.LINK_ISSUE:
      return /*#__PURE__*/_jsx(Chain, {});

    case Icon.ARCHIVE:
      return /*#__PURE__*/_jsx(Archive, {});

    case Icon.COPY:
      return /*#__PURE__*/_jsx(Copy, {});

    case Icon.RECOVERY:
      return /*#__PURE__*/_jsx(Recovery, {});

    case Icon.CREATE_FILTER:
      return /*#__PURE__*/_jsx(PlusFilter, {});

    case Icon.EDIT_FILTER:
      return /*#__PURE__*/_jsx(SettingFilter, {});

    case Icon.REMOVE_FILTER:
      return /*#__PURE__*/_jsx(CrossOutedFilter, {
        color: "#353B60",
        width: "24px",
        height: "24px"
      });

    case Icon.PASTE_FROM_SEARCH:
      return /*#__PURE__*/_jsx(SuccessfulContentPaste, {
        color: "#353B60",
        width: "24px",
        height: "24px"
      });

    default:
      break;
  }
}; // eslint-disable-next-line @typescript-eslint/no-explicit-any


export var ContextMenuItem = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var tooltipTitle = _ref.tooltipTitle,
      icon = _ref.icon,
      customIcon = _ref.customIcon,
      separatorTop = _ref.separatorTop,
      disabled = _ref.disabled,
      loading = _ref.loading,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  if (tooltipTitle) {
    return /*#__PURE__*/_jsx(Tooltip, {
      placement: "top",
      title: tooltipTitle,
      children: /*#__PURE__*/_jsxs("div", {
        children: [separatorTop && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(MenuItem, _objectSpread(_objectSpread({
          separatorTop: separatorTop,
          disabled: disabled || loading // eslint-disable-next-line @typescript-eslint/no-explicit-any

        }, otherProps), {}, {
          ref: ref,
          children: [icon && !loading && /*#__PURE__*/_jsx(ListItemIcon, {
            children: getIcon(icon)
          }), loading && /*#__PURE__*/_jsx(ListItemIcon, {
            children: /*#__PURE__*/_jsx(CircularProgress, {
              size: 24
            })
          }), customIcon && /*#__PURE__*/_jsx(ListItemIcon, {
            children: customIcon
          }), /*#__PURE__*/_jsx(Typography, {
            variant: "inherit",
            children: otherProps.children
          })]
        }))]
      })
    });
  }

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [separatorTop && /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs(MenuItem, _objectSpread(_objectSpread({
      disabled: disabled || loading
    }, otherProps), {}, {
      children: [icon && !loading && /*#__PURE__*/_jsx(ListItemIcon, {
        children: getIcon(icon)
      }), loading && /*#__PURE__*/_jsx(ListItemIcon, {
        children: /*#__PURE__*/_jsx(CircularProgress, {
          size: 24
        })
      }), customIcon && /*#__PURE__*/_jsx(ListItemIcon, {
        children: customIcon
      }), /*#__PURE__*/_jsxs(Typography, {
        variant: "inherit",
        children: [" ", otherProps.children]
      })]
    }))]
  });
});
ContextMenuItem.displayName = 'ContextMenuItem';